const styles = {
  CheckboxWrapper: `
    margin-right: 30px;

    @media (max-width: 600px) {
      & { margin-right: 15px; }
    }
  `,
  ClientRow: `
    display: grid;
    grid-template-columns: auto 1fr auto auto 140px auto;
    align-items: center;
    border-top: 1px solid lightgrey;
    padding: 5px 5px 5px 20px;
    font-size: 16px;
    margin-top: -1px;

    & > span:first-child {
      padding-right: 8px;
    }

    &:last-child {
      border-bottom: 1px solid lightgrey;
    }

    @media (max-width: 600px) {
      && {
        padding-right: 0px;
        grid-template-columns: auto 1fr auto auto 100px auto;
      }
    }
  `,
  ClientTaskRow: `
    display: grid;
    grid-template-columns: auto 1fr auto auto 140px auto;
    align-items: center;
    margin-left: 50px;
    border-top: 1px solid lightgrey;
    border-left: 1px solid lightgrey;
    padding: 5px 46px 5px 20px;
    font-size: 16px;
    background-color: #f9f9f9;

    & > span:first-child {
      padding-right: 8px;
    }

    &:first-child {
      border-top: none;
    }

    @media (max-width: 600px) {
      && {
        margin-left: 15px;
        padding-right: 26px;
        grid-template-columns: auto 1fr auto auto 100px auto;
      }
    }
  `,
  ErrorIcon: `
    && {
      fill: #ff7979;
      font-size: 24px;
      position: relative;
      left: -6px;
    }
  `,
  InputAdornment: `
    &&&&& {
      margin-top: 0px;
      margin: 0px;
    }

    & > p {
      font-size: 16px;
      font-family: 'Open Sans';
      color: black;
    }
  `,
  KeyboardArrowDown: `
    && {
      fill: #757575;
      font-size: 26px;
      margin: 0px 8px;
      cursor: pointer;
    }

    @media (max-width: 600px) {
      && { margin: 0px; }
    }

    &.rotated {
      transition: transform 500ms ease;
      transform: rotate( 0deg );
    }

    &.unrotated {
      transition: transform 500ms ease;
      transform: rotate( -90deg );
    }
  `,
  MonetizationOn: `
    && {
      fill: #57AD68;
      font-size: 24px;
    }
  `,
  RatesTableHeader: `
    display: grid;
    grid-gap: 15px;
    margin-top: 20px;
    margin-bottom: 15px;
    margin-right: 15px;
    font-size: 18px;
    align-items: center;

    @media (max-width: 600px) {
      & {
        grid-gap: 5px;
      }
    }
  `,
  RatesHeaderItem: `
    display: grid;
    grid-template-columns: auto;
    grid-gap: 4px;
    align-items: center;
    margin-right: -2px;

    @media (max-width: 600px) {
      & {
        margin-right: 0px;
      }
    }
  `,
  RateTextField: `
    &.MuiTextField-root {
      margin: 5px 0px;
    }

    .MuiFilledInput-root, .MuiFilledInput-root:focus {
      background-color: #f1f1f1;
    }

    .MuiFilledInput-root:hover  {
      background-color: #ececec;
    }

    input {
      font-family: 'Open Sans';
      font-size: 16px;
      padding: 5px 15px 5px 5px;
      max-width: 120px;
      height: 30px;
    }

    @media (max-width: 600px) {
      input {
        max-width: 90px;
        padding: 5px 8px;
      }
    }
  `,
  Refresh: `
    && {
      margin-right: 15px;
      font-size: 44px;
      padding: 10px;
      cursor: pointer;

      @media (max-width: 600px) {
        && {
          margin-right: 5px;
        }
      }
    }
  `,
  RefreshHeader: `
    && {
      font-size: 44px;
      padding: 10px;
      cursor: pointer;
    }
  `,
  ShowAll: `
    display: grid;
    justify-items: end;
    font-size: 18px;
    cursor: pointer;
    color: #1e88e5;
  `,
  TaskRow: `
    display: grid;
    grid-template-columns: auto 1fr auto auto auto 140px auto;
    align-items: center;
    border-top: 1px solid lightgrey;
    padding: 5px 5px 5px 20px;
    font-size: 16px;
    margin-top: -1px;

    &:last-child {
      border-bottom: 1px solid lightgrey;
    }

    @media (max-width: 600px) {
      && {
        padding-right: 0px;
        grid-template-columns: auto 1fr auto auto auto 100px auto;
      }
    }
  `,
}

export default styles;
